import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Options } from 'ng5-slider';
import { CTSilderSetting, SilderSetting } from '../../../element/service/recordview-param';
import { SliderConditionalValue } from '../../model/model';
import { ConditionalTemplateRunner } from '../../service/data';

@Component({
	selector: 'common-ct-runner-silder',
	templateUrl: './ct-runner-silder.component.html',
	styleUrls: ['./ct-runner-silder.component.scss']
})
export class CtRunnerSilderComponent implements OnInit {
	@HostBinding('class.ct-runner-silder') hostClass = true;
	_data: ConditionalTemplateRunner;
	get data(): ConditionalTemplateRunner {
		return this._data;
	}
	@Input() set data(val: ConditionalTemplateRunner) {
		this._data = val;
		this.options = new SilderSetting(this.setting).toOptions();
	}
	get setting(): CTSilderSetting {
		if (this.data) {
			return this.data.Setting as CTSilderSetting;
		}
		return undefined;
	}
	options: Options = SilderSetting.defaultOptions();

	get lowValue(): number {
		const r = this.data.Data.Value as SliderConditionalValue;
		if (r) {
			return r.LowValue;
		}
		return this.setting.Min;
	}
	set lowValue(val: number) {
		let r = this.data.Data.Value as SliderConditionalValue;
		if (!r) {
			r = {} as SliderConditionalValue;
			this.data.Data.Value = r;
		}
		if (this.setting.NegativeInfinity) {
			r.NegativeInfinity = val === this.setting.Min;
		}
		if (!r.Ratio) {
			r.Ratio = this.setting.Ratio;
		}
		r.LowValue = val;
		this.data.enable = r.LowValue !== this.setting.Min || r.HighValue !== this.setting.Min;
	}
	get highValue(): number {
		const r = this.data.Data.Value as SliderConditionalValue;
		if (r) {
			return r.HighValue;
		}
		return this.setting.Min;
	}
	set highValue(val: number) {
		let r = this.data.Data.Value as SliderConditionalValue;
		if (!r) {
			r = {} as SliderConditionalValue;
			this.data.Data.Value = r;
		}
		if (this.setting.PositiveInfinity) {
			r.PositiveInfinity = val === this.setting.Max;
		}
		if (!r.Ratio) {
			r.Ratio = this.setting.Ratio;
		}

		// è¿ä¸å¥å¿é¡»å¨æåï¼å¦åæ§è¡åä¼è·³åºå½æ°ï¼åå æªç¥
		r.HighValue = val;
		this.data.enable = r.LowValue !== this.setting.Min || r.HighValue !== this.setting.Min;
	}
	constructor() {}

	ngOnInit() {}
}
